import { apiUrl } from "utils/urls";

import axios from "axios";
import moment from "moment";

export const getDateFromString = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD");
};

export const getTimeFromString = (dateString) => {
    return moment(dateString).format("HH:mm");
};

export const dateKr = (dateString) => {
    return moment(dateString).format("YYYY년 MM월 DD일");
};
